export const ESCALATIONS_ROUTES = {
  __ROOT__: '/escalations',
}
